import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=6d06402f&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=6d06402f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06402f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d06402f')) {
      api.createRecord('6d06402f', component.options)
    } else {
      api.reload('6d06402f', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=6d06402f&scoped=true&", function () {
      api.rerender('6d06402f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/message/settings.vue"
export default component.exports